import { getEncounterBreakdown } from "@/api/encounters";
import type { EncounterBreakdown } from "@/api/encounters";
import { useQuery } from "@tanstack/react-query";
import dayjs from "dayjs";

interface UseEncounterBreakdownOptions {
  customerIds?: string[];
  dateFrom?: string;
  dateTo?: string;
}

export function toDateOnly(iso: string | undefined): string | undefined {
  if (!iso) return undefined;
  const d = dayjs(iso);
  return d.isValid() ? d.format("YYYY-MM-DD") : undefined;
}

export function useEncounterBreakdown(options?: UseEncounterBreakdownOptions) {
  const { customerIds, dateFrom, dateTo } = options ?? {};
  const dischargeDateFrom = toDateOnly(dateFrom);
  const dischargeDateTo = toDateOnly(dateTo);

  const { data, isLoading, error, refetch } = useQuery<EncounterBreakdown>({
    queryKey: ["encounter-breakdown", customerIds?.join(","), dateFrom, dateTo],
    queryFn: () =>
      getEncounterBreakdown({
        customerIds: customerIds?.length ? customerIds : undefined,
        dischargeDateFrom,
        dischargeDateTo,
      }),
    staleTime: 30000,
    gcTime: 5 * 60 * 1000,
  });

  return { data, isLoading, error, refetch };
}
